(function () {
  var dataEl = document.getElementById('cap-pdp-fitment-json');
  var rawText = (dataEl && dataEl.textContent || '').trim();
  var fitment = {};
  if (rawText) {
    try { fitment = JSON.parse(rawText) || {}; } catch (e) { fitment = {}; }
  }

  var LABELS = {
    side: function (v) {
      var pos = fitment.position;
      var posPrefix = (pos && pos !== 'both') ? pos.toUpperCase() + ' ' : '';
      if (v === 'both') {
        return 'This is a single part that fits either ' + posPrefix.toLowerCase() + 'side — it does NOT include both sides';
      }
      var text = 'This part is for the ' + posPrefix + v.toUpperCase() + ' side';
      if (pos === 'both') {
        text += ' (fits either front or rear — single part, not a pair)';
      }
      return text;
    },
    position: function (v) {
      if (v === 'both') return 'This is a single part that fits either the front or rear — it does NOT include both';
      return 'This part is for the ' + v.toUpperCase() + ' position';
    },
    color: function (v) { return 'This part\'s color/finish is: ' + v; },
    engine: function (v) { return 'Only fits vehicles that came from the factory with the ' + v + ' engine'; },
    option_package: function (v) { return 'Only fits vehicles that came from the factory with: ' + v; },
    other_qualifiers: function (v) { return v; }
  };

  var warnings = [];
  if (fitment.side) {
    warnings.push(LABELS.side(fitment.side));
  } else if (fitment.position) {
    warnings.push(LABELS.position(fitment.position));
  }
  ['color', 'engine', 'option_package', 'other_qualifiers'].forEach(function (field) {
    if (fitment[field]) warnings.push(LABELS[field](fitment[field]));
  });

  // Nothing to confirm on this product - don't touch the page at all.
  if (warnings.length === 0) return;

  var backdrop = document.getElementById('cap-pdp-modal-backdrop');
  var checkEl = document.getElementById('cap-pdp-modal-check');
  var explainerEl = document.getElementById('cap-pdp-modal-explainer');
  var confirmBtn = document.getElementById('cap-pdp-modal-confirm');
  var cancelBtn = document.getElementById('cap-pdp-modal-cancel');
  var prompt = document.getElementById('cap-pdp-prompt');
  var promptBtn = document.getElementById('cap-pdp-prompt-btn');
  if (!backdrop || !checkEl || !explainerEl || !confirmBtn || !cancelBtn || !prompt || !promptBtn) return;
  checkEl.innerHTML = warnings.map(function (w) { return '✔ ' + w; }).join('<br>');

  var hasPartVariant = !!(fitment.side || fitment.position || fitment.color);
  var hasFactoryOption = !!(fitment.engine || fitment.option_package);
  var explainerText;
  var confirmText;
  if (hasPartVariant && hasFactoryOption) {
    explainerText = 'This part comes in different versions, and it only fits vehicles with certain factory-installed options. Please confirm both match your vehicle before ordering.';
    confirmText = 'Yes, this is correct for my vehicle';
  } else if (hasPartVariant) {
    explainerText = 'This part comes in different versions. Please confirm you\'re ordering the correct one for your vehicle.';
    confirmText = 'Yes, this is the right one';
  } else if (hasFactoryOption) {
    explainerText = 'This part only fits vehicles that came from the factory with certain options. Please verify your vehicle has these before ordering.';
    confirmText = 'My vehicle has these options';
  } else {
    explainerText = 'Please double-check the details below before ordering.';
    confirmText = 'Confirmed';
  }
  explainerEl.textContent = explainerText;
  confirmBtn.textContent = confirmText;

  var noteValue = warnings.join(' — ');

  var variantIdEl = document.getElementById('cap-pdp-variant-id');
  var variantId = null;
  try { variantId = JSON.parse((variantIdEl && variantIdEl.textContent) || 'null'); } catch (e) { variantId = null; }

  function addNoteToForm(form) {
    if (!form) return;
    var existing = form.querySelector('input[name=\"properties[Customer Confirmed Fitment]\"]');
    if (existing) { existing.value = noteValue; return; }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Customer Confirmed Fitment]';
    input.value = noteValue;
    form.appendChild(input);
  }

  function findForm() {
    return document.querySelector('form.js-product-form-main') || document.querySelector('form[action^=\"/cart/add\"]');
  }

  // Remember a confirmation so the customer is only asked once per product.
  var storeKey = 'cap-fitment-ok:' + location.pathname;
  var confirmed = false;
  try { confirmed = sessionStorage.getItem(storeKey) === noteValue; } catch (e) { confirmed = false; }

  function markConfirmed() {
    confirmed = true;
    try { sessionStorage.setItem(storeKey, noteValue); } catch (e) {}
  }

  var dynamicCheckoutBlock = document.querySelector('.product-info__dynamic-checkout-button');
  var hasWallet = !!(dynamicCheckoutBlock && dynamicCheckoutBlock.children.length > 0);

  if (confirmed) {
    prompt.classList.remove('active');
    if (dynamicCheckoutBlock) dynamicCheckoutBlock.classList.remove('cap-pdp-dimmed');
    addNoteToForm(findForm());
  } else if (hasWallet) {
    dynamicCheckoutBlock.classList.add('cap-pdp-dimmed');
    prompt.classList.add('active');
  }

  var pendingAction = null; // 'cart' | 'buynow'

  // Intercept Add to Cart only until fitment has been confirmed.
  document.addEventListener('click', function (e) {
    var addBtn = e.target.closest('button[name=\"add\"]');
    if (!addBtn) return;
    if (confirmed) {
      addNoteToForm(findForm());
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    pendingAction = 'cart';
    backdrop.classList.add('active');
  }, true);

  promptBtn.addEventListener('click', function () {
    pendingAction = 'buynow';
    backdrop.classList.add('active');
  });

  confirmBtn.onclick = function () {
    backdrop.classList.remove('active');
    markConfirmed();

    if (pendingAction === 'cart') {
      if (variantId) {
        var params = new URLSearchParams();
        params.set('id', variantId);
        params.set('quantity', '1');
        params.set('properties[Customer Confirmed Fitment]', noteValue);
        params.set('return_to', '/cart');
        window.location.href = '/cart/add?' + params.toString();
      } else {
        addNoteToForm(findForm());
        var realAdd = document.querySelector('button[name=\"add\"]');
        if (realAdd) realAdd.click();
      }
    } else if (pendingAction === 'buynow') {
      prompt.classList.remove('active');
      if (dynamicCheckoutBlock) dynamicCheckoutBlock.classList.remove('cap-pdp-dimmed');
      addNoteToForm(findForm());
    }
  };
  cancelBtn.onclick = function () {
    backdrop.classList.remove('active');
  };
})();
